<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">

        
        <h4>List of Job Function</h4>
        
        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <Button
            label="New Job Function"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            style="margin-right: 1em"
            @click="openNew"
          />
          <div>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filters"
                placeholder="Global Search"
                style="margin-right: 0.5em"
                @input="updateSearch"
              />
            </span>
          </div>
        </div>

        <JobFunctionsTable
          :key="jobFunctionsKey"
          :jobFunctions="jobFunctions"
          :loading="loading"
          @edit-jobFunction="editJobFunction"
          @delete-jobFunction="deleteJobFunction"
        />

        <JobFunctionsForm
          :jobFunctionToEdit="jobFunction"
          :key="jobFunctionsFormKey"
          :jobFunctionsForm="jobFunctionsForm"
          :sendingRequest="sendingRequest"
          :disabledArr="disabledArr"
          @close="jobFunction = {}, jobFunctionsForm = false"
          @save="saveJobFunction"
        />

      </div>
    </div>
  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";

import JobFunctionsTable from './JobFunctionsTable'
import JobFunctionsForm from './JobFunctionsForm'

export default {
  components: {
    JobFunctionsTable,
    JobFunctionsForm
  },
  data: () => ({
    customerService: new CustomerService(),
    filters: '',
    jobFunctionsKey1: 0,
    jobFunctions: [],
    jobFunctionsForm: false,
    jobFunctionsFormKey1: 0,
    disabledArr: [],
    jobFunction: {},
    requesting: false,
    sendingRequest: false
  }),
  computed: {
    jobFunctionsKey: {
      set(val) {
        this.jobFunctionsKey1++
      },
      get() {
        return 'JobFunctionsTable' + this.jobFunctionsKey1.toString()
      }
    },
    jobFunctionsFormKey: {
      set(val) {
        this.jobFunctionsFormKey1++
      },
      get() {
        return 'JobFunctionsForm' + this.jobFunctionsFormKey1.toString()
      }
    },
    loading() {
      if (this.jobFunctions && this.jobFunctions[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    }
  },
  created() {
    this.getAllJobFunctionsByHard()
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }
  },
  watch: {
    filters(val) {
      this.jobFunctionsKey++
    },
    jobFunctionsForm(val) {
      this.jobFunctionsFormKey++
    },
    jobFunctions(val) {
      if (val && Array.isArray(val)) {
        this.jobFunctionsKey++
      }
    }
  },
  methods: {
    deleteJobFunction(jobFunction) {
      if (jobFunction && jobFunction.id) {
        this.customerService
          .deleteJobFunction(jobFunction.id)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "Job Function deleted",
              detail: "Job Function updated deleted.",
              life: 5000,
            });
          
            this.jobFunctionsForm = false
            this.getAllJobFunctionsByHard()
          })
          .catch(err => {
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while deleting Job Function",
              life: 5000,
            })
          })
      }
    },
    editJobFunction(jobFunction) {
      
      this.jobFunction = jobFunction
      this.jobFunctionsForm = true
    },
    saveJobFunction(jobFunction) {
      

      this.sendingRequest = true

      if (jobFunction.id) {

        this.customerService
          .editJobFunction(jobFunction)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "Job Function updated",
              detail: "Job Function updated successfully.",
              life: 5000,
            });
          
            this.sendingRequest = false
            this.jobFunctionsForm = false
            this.getAllJobFunctionsByHard()
          })
          .catch(err => {
            this.sendingRequest = false
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating Job Function",
              life: 5000,
            })
          })
      } else {
        this.customerService
          .saveJobFunction(jobFunction)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "Job Function saved",
              detail: "Job Function saved successfully.",
              life: 5000,
            })
          
            this.sendingRequest = false
            this.jobFunctionsForm = false
            this.getAllJobFunctionsByHard()
          })
          .catch(err => {
            this.sendingRequest = false
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving Job Function",
              life: 5000,
            })
          })
      }
    },
    getAllJobFunctionsByHard() {
      this.requesting = true
      this.customerService
        .getAllJobFunctionsByHard()
        .then(data => {
          this.requesting = false
          this.jobFunctions = data
        })
        .catch(err => {
          this.requesting = false
          
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting Job Functions",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "jobFunctions"'
          })
        })
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    },
    openNew() {
      this.jobFunction = {}
      this.jobFunctionsForm = true
    }
  }
}
</script>

<style>

</style>